module.exports = __webpack_public_path__ + "assets/img/simply-Brand_03.578a1595.png";